import React from "react";
import DataTable from "../../../components/DataTable";

const SubjectCategories = () => (
  <DataTable
    title="Subject Categories"
    apiPath="/api/admin/master/subject-categories"
    columns={[
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
      { key: "code", label: "Code" },
      { key: "sortOrder", label: "Sort Order" },
    ]}
    formFields={[
      { key: "name", label: "Name (e.g. Major)", required: true },
      { key: "code", label: "Code (e.g. MAJOR)", required: true },
      { key: "sortOrder", label: "Sort Order", type: "number" },
    ]}
    transformSubmit={(data) => ({
      name: data.name,
      code: data.code,
      sortOrder: parseInt(data.sortOrder) || 0,
    })}
  />
);

export default SubjectCategories;
